import styles from './ArticlesOverviewPanel.module.scss';
import { Empty, List, Pagination } from 'antd';
import { useSearchArticlesQuery } from '@/redux/articles';
import { ArticleStatus } from '@/core/http.articles';
import { useDefaultTablePaging } from '@/components';
import { useEffect } from 'react';
import { ArticleOverviewListItem } from './ArticleOverviewListItem';

export interface ArticlesOverviewPanelProps {
  searchString?: string;
}

export function ArticlesOverviewPanel(props: ArticlesOverviewPanelProps) {
  const { searchString } = props;
  const { setTotal, paging, params } = useDefaultTablePaging();
  const { setPage } = paging;
  const { data: paged, isFetching } = useSearchArticlesQuery({
    statuses: [ArticleStatus.Published],
    paging: params,
    searchString,
  });

  useEffect(() => {
    setPage(1);
  }, [searchString, setPage]);

  useEffect(() => {
    setTotal(paged?.total ?? 0);
  }, [paged?.total, setTotal]);

  if (isFetching) {
    return <List loading className={styles.list} />;
  }

  const articles = paged?.items;

  if (!articles?.length) {
    return <Empty />;
  }

  return (
    <>
      <List
        rowKey="id"
        dataSource={articles}
        className={styles.list}
        renderItem={(article) => <ArticleOverviewListItem article={article} />}
      />

      <Pagination {...paging} className={styles.pagination} />
    </>
  );
}
